import { render } from "./ModalCategory.vue?vue&type=template&id=737a195a"
import script from "./ModalCategory.vue?vue&type=script&lang=js"
export * from "./ModalCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__